import { useRouterState } from "@tanstack/react-router";

import { useConsumeAccountCreationCallback } from "@/hooks/use-consume-account-creation-callback";
import { useSyncAnalyticsViewer } from "@/hooks/use-sync-analytics-viewer";
import { shouldLoadAnalytics } from "@/lib/analytics";

export function RootAnalyticsTracking({
  isAdmin,
  userId,
}: Readonly<{ isAdmin: boolean; userId: string | null }>) {
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  if (isAdmin || !shouldLoadAnalytics(pathname)) return null;

  return <PublicAnalyticsTracking userId={userId} />;
}

function PublicAnalyticsTracking({ userId }: Readonly<{ userId: string | null }>) {
  useSyncAnalyticsViewer();
  useConsumeAccountCreationCallback(userId);
  return null;
}
